import { withNamespace } from '../helper';

const namespace = '@GLOBAL';

export const ERROR = withNamespace('ERROR', namespace);
export const RECALL_ACTIONS_FAIL = withNamespace('RECALL_ACTIONS_FAIL', namespace);
